// Module
var code = "<p>Select a form below to download and check your downloads folder.</p> ";
// Exports
export default code;